import ReducerRegistry from '../redux/ReducerRegistry';
import { SET_MEDIA_HEALTH } from './actionTypes';
import { MEDIA_HEALTH } from './constants';
const DEFAULT_STATE = {
    state: MEDIA_HEALTH.OK,
    reason: undefined,
    since: 0,
};
ReducerRegistry.register('features/base/media-health', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_MEDIA_HEALTH:
            // 같은 상태의 반복 dispatch 는 since 를 유지해 배지 경과시간이 튀지 않게 한다
            if (state.state === action.state) {
                return state.reason === action.reason ? state : { ...state, reason: action.reason };
            }
            return {
                state: action.state,
                reason: action.reason,
                since: action.since,
            };
    }
    return state;
});
